import { render } from "./SingleVerify.vue?vue&type=template&id=663f05ac&scoped=true"
import script from "./SingleVerify.vue?vue&type=script&lang=js"
export * from "./SingleVerify.vue?vue&type=script&lang=js"

import "./SingleVerify.vue?vue&type=style&index=0&id=663f05ac&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663f05ac"]])

export default __exports__